var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 22 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.35902 3.35826C6.42396 3.26798 6.49609 3.15745 6.58807 3.00841C6.62167 2.95396 6.7133 2.80278 6.78153 2.69022L6.78156 2.69017L6.8584 2.56354C7.6183 1.32052 8.17069 0.75 9.16675 0.75H13.7501V2.58333H9.16675C9.08725 2.58333 8.83721 2.84158 8.4226 3.51979L8.35588 3.62974C8.28708 3.74326 8.18683 3.90868 8.14821 3.97125C8.03551 4.15388 7.94185 4.29739 7.84731 4.42882C7.43642 5.00004 7.02573 5.33333 6.41675 5.33333H3.66675C3.16049 5.33333 2.75008 5.74374 2.75008 6.25V14.5C2.75008 15.0063 3.16049 15.4167 3.66675 15.4167H18.3334C18.8397 15.4167 19.2501 15.0063 19.2501 14.5V9H21.0834V14.5C21.0834 16.0188 19.8522 17.25 18.3334 17.25H3.66675C2.14796 17.25 0.916748 16.0188 0.916748 14.5V6.25C0.916748 4.73122 2.14796 3.5 3.66675 3.5H6.24826C6.27878 3.46511 6.31619 3.4178 6.35902 3.35826ZM15.5834 5.33333V3.5H17.4167V1.66667H19.2501V3.5H21.0834V5.33333H19.2501V7.16667H17.4167V5.33333H15.5834ZM11.0001 14.5C8.46878 14.5 6.41675 12.448 6.41675 9.91667C6.41675 7.38536 8.46878 5.33333 11.0001 5.33333C13.5314 5.33333 15.5834 7.38536 15.5834 9.91667C15.5834 12.448 13.5314 14.5 11.0001 14.5ZM11.0001 12.6667C12.5189 12.6667 13.7501 11.4355 13.7501 9.91667C13.7501 8.39788 12.5189 7.16667 11.0001 7.16667C9.4813 7.16667 8.25008 8.39788 8.25008 9.91667C8.25008 11.4355 9.4813 12.6667 11.0001 12.6667Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }